import {SpinnerJSX} from "../../../../ticketsystem/modules/components/Spinner";
import React from "react";
import {IntlMessage} from "../../../../../@WUM/core/Elements";
import {IntlMessageValue} from "../../../../../@WUM/core/component/const/IntlMessage";
import {DynamikOffCanvas} from "../../../../../@WUM/core/component/const/DynamikModal";
import {WorkLogEntry} from "../../../API/request/ticket.interface";
import {TicketTimeTrackingTable} from "./TicketTimeTrackingTable";
import {responsibilityApiTYpe} from "../../../../ticketsystem/API/request/responsibility.Api,interface";
import {TicketTimeTracking} from "./TicketTimeTracking";
import {ToastFn} from "../../../../worktimetracking/Pages/components/save/SubmitHandler";
import {ResponseNoteActivityReport} from "../../../API/response/ticketsystem2";

interface TicketTimeTrackingOverviewProps {
    id?: string
    Store: any
    showReportDetail: boolean
    handleCloseReportDetail: () => void
    handleShowReportDetail: () => void
    setShowReportDetail: React.Dispatch<React.SetStateAction<boolean>>;
    response?: WorkLogEntry[] | undefined | boolean;
    users?: responsibilityApiTYpe[]
    setReload: React.Dispatch<React.SetStateAction<boolean>>
    reload: boolean
    showToast: ToastFn;
}

export const TicketTimeTrackingOverview = (props: TicketTimeTrackingOverviewProps): JSX.Element => {

    const {id, Store, showReportDetail, handleCloseReportDetail, handleShowReportDetail, setShowReportDetail, response, users, setReload, reload, showToast } = props

    const [recordId, setRecordId] = React.useState("")

    const responseNoteActivityReport = ResponseNoteActivityReport(id, recordId, reload)

    if (id === undefined) {
        return <SpinnerJSX messageId={'common.loading'} />
    }

    let handlesubmit;
    return (
        <>
            <DynamikOffCanvas
                openButtonLabel={<><span className="material-symbols-outlined pr-2" style={{verticalAlign:'bottom'}}>
                                avg_time
                            </span>
                    <IntlMessage messageId="ticket.button.seeRecords" Store={Store} /></>}
                saveButtonLabel={IntlMessageValue('de', 'common.save', Store)}
                closeButtonLabel={IntlMessageValue('de', 'common.close', Store)}
                title={IntlMessageValue("de","ticket.time.entries",Store)}
                ClassOpenButton={'float-end'}
                ClassSaveButton={'float-end'}
                body={<div className={"mb-3"}>

                    <div className="" >
                        <TicketTimeTrackingTable response={response} Store={Store} id={id} users={users} setReload={setReload} reload={reload} setRecordId={setRecordId} showToast={showToast} />
                    </div>

                    <TicketTimeTracking id={id} Store={Store} response={response} setReload={setReload} reload={reload} recordId={recordId} setRecordId={setRecordId} showToast={showToast} activityRecord={responseNoteActivityReport} />

                </div>}
                handlesubmit={handlesubmit}
                handleShow={handleShowReportDetail}
                show={showReportDetail}
                id={'TaskNew'}
                setShow={setShowReportDetail}
                handleClose={handleCloseReportDetail}
                noForm={true}
            />
        </>
    )
}